import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';
import { secondaryButtonStyle } from '../../styles/buttons.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useMinorTestCardStyles = makeStyles(() => ({
  testCard: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    height: '100%',
    minHeight: 100,
    padding: 12,
    border: `1px solid ${colors.surfaceBorder}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    overflow: 'hidden',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    '&:hover:not(:disabled)': {
      backgroundColor: colors.hoverSurface,
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.72,
    },
  },
  minorCard: {
    borderTopRightRadius: 40,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      borderTopRightRadius: radius.sm,
    },
  },
  imageWrap: {
    position: 'relative',
    width: '100%',
    aspectRatio: '1 / 1',
    borderRadius: radius.sm,
    overflow: 'hidden',
    backgroundColor: colors.progressTrackMuted,
  },
  minorImageWrap: {
    borderTopRightRadius: 32,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      borderTopRightRadius: radius.sm,
    },
  },
  image: {
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: 'cover',
  },
  statusBadge: {
    position: 'absolute',
    top: spacing.xs,
    left: spacing.xs,
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: 25,
    padding: '0 8px',
    borderRadius: radius.sm,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: 'normal',
    zIndex: 2,
  },
  statusDone: {
    backgroundColor: colors.successSurface,
    color: colors.successDark,
  },
  statusProgress: {
    backgroundColor: colors.infoSurface,
    color: colors.infoDark,
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  cardBody: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: spacing.sm,
  },
  cardText: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: spacing.xs,
  },
  cardTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.base,
    color: colors.link,
    letterSpacing: 0.32,
    lineHeight: 1.4,
  },
  registeredMark: {
    color: colors.primary,
  },
  cardDescription: {
    margin: 0,
    display: '-webkit-box',
    overflow: 'hidden',
    color: colors.link,
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    letterSpacing: 0.24,
    lineHeight: 1.4,
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 3,
    '& p, & h3': {
      margin: 0,
      display: 'inline',
    },
    '& p:not(:last-child)::after': {
      content: '" "',
    },
    '& *': {
      fontFamily: `${fonts.opensans} !important`,
      background: 'transparent !important',
    },
    '& a': {
      color: `${colors.link} !important`,
    },
  },
  timeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 'auto',
    flexShrink: 0,
    color: colors.brownLight,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
  },
  timeIcon: {
    width: 16,
    height: 16,
    color: '#c96d3d',
  },
  cardButton: {
    ...secondaryButtonStyle,
    alignSelf: 'stretch',
    flexShrink: 0,
    width: '100%',
    padding: '0 16px',
    pointerEvents: 'none',
  },
  cardButtonIcon: {
    width: 16,
    height: 16,
  },
  lockOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: 95,
    backgroundColor: 'rgba(255, 255, 255, 0.32)',
    zIndex: 3,
    pointerEvents: 'none',
  },
  lockIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: colors.white,
    color: colors.text,
  },
  lockIcon: {
    width: 24,
    height: 24,
  },
}));
